<template>
    <transition name="slide-up">
        <div class="sliding-panel">
            <div class="sliding-panel-header">
                <IconUserList />
                <div class="sliding-panel-title">
                    <h6>{{ $t("message.preferredRepresentative") }}</h6>
                </div>
                <div class="arrow-wrapper" @click="closePanel">
                    <md-icon class="arrow-button">keyboard_arrow_down</md-icon>
                </div>
            </div>
            <div class="search-bar-wrapper">
                <input type="text" v-model="searchQuery" :placeholder="$t('message.searchRepresentative')" class="search-bar" />
                <span class="search-icon">
                    <md-icon>search</md-icon>
                </span>
            </div>
            <div class="agent-list">
                <div v-for="agent in filteredAgents" :key="agent._id" class="agent-item">
                    <span @click="toggleAgent(agent)" class="agent-name">{{ agent.name }}</span>
                    <input type="checkbox" v-model="selectedAgents" :value="agent._id" class="checkbox" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import IconUserList from "./icons/IconUserList.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    props: {
        visitorId: {
            type: String,
            required: true,
        },
        preferredAgents: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        IconUserList,
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site, // site bilgisi için
        }),
        filteredAgents() {
            return this.users.filter((agent) => agent.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
    },
    data: function () {
        return {
            searchQuery: "",
            selectedAgents: this.preferredAgents,
        };
    },
    methods: {
        ...mapActions({
            updatePreferredAgents: "visitor/updatePreferredAgents",
        }),
        closePanel() {
            this.$emit("close");
        },
        toggleAgent(agent) {
            if (this.selectedAgents.includes(agent._id)) {
                this.selectedAgents = this.selectedAgents.filter((id) => id !== agent._id);
            } else {
                this.selectedAgents.push(agent._id);
            }
        },
    },
    watch: {
        selectedAgents: {
            handler: _.debounce(function () {
                if (!_.isEqual(this.selectedAgents, this.preferredAgents)) {
                    console.log("selected agents", this.selectedAgents);
                    this.$emit("select", this.selectedAgents);
                }
            }, 500),
            deep: true,
        },
        preferredAgents: {
            handler() {
                if (!_.isEqual(this.selectedAgents, this.preferredAgents)) {
                    this.selectedAgents = this.preferredAgents;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.sliding-panel {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    z-index: 99999;
    will-change: transform;
}

.sliding-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    gap: 10px;
    padding: 10px;
}

.arrow-wrapper {
    cursor: pointer;
}

.sliding-panel-title h6 {
    margin: 0;
}

.search-bar-wrapper {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
}

.search-bar {
    width: 100%;
    padding: 10px 40px 10px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #ccc;
}

.agent-list {
    max-height: 500px;
    overflow-y: auto;
}

.agent-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.agent-item:hover {
    background: #f1f4f7;
}

.agent-name {
    flex-grow: 1;
}

.checkbox {
    margin-left: 10px;
}
</style>
